<template>
  <div class="content">
    <n-card :more="true" title="About Me">
      <div class="user-content">
        <div class="left">
          <Avatar class="avatar" style :src="avatar || 'https://i.loli.net/2017/08/21/599a521472424.jpg'" />
          <label class="title">{{ name }}</label>
          <span class="sub-title">{{ occupy }}</span>
        </div>
        <div class="right-form">
          <div class="form-item">
            <label><Icon type="md-mail" color="#ccc" size="16"/> MAIL</label>
            <Input class="form-input" v-model="mail" readonly placeholder="Enter something..."/>
          </div>
          <div class="form-item">
            <label><Icon type="ios-text" color="#ccc" size="16"/>  WECHAT</label>
            <Input class="form-input" v-model="phone" readonly placeholder="Enter something..."/>
          </div>
          <div class="form-item">
            <label><Icon type="ios-calendar" color="#ccc" size="16"/> BIRTH</label>
            <DatePicker class="form-input" v-model="birth" type="date" placeholder="Select date" readonly></DatePicker>
          </div>
        </div>
      </div>
      <Icon slot="extra" type="ios-calendar" color="#ccc" size="16"/>
    </n-card>
  </div>
</template>
<script>
import nCard from '@/components/profile/nCard.vue'
export default {
  components: {
    nCard
  },
  data() {
    return {
      avatar: "U2FsdGVkX18WFAKoA9yiRodfQy7fhMIL/VXK6YjW86wTnVxXHAEz+NnYssftccrsCL7/6cXVKpXIX08DkAEUkCGwxhFJJiPzaQ6MC8irBHunZpVOxuvhgu5c9wzIN7/M",
      name: "U2FsdGVkX18KA3I0NEHLzGvuN1Ovl9BSbKQI6VCi+EI=",
      phone: "U2FsdGVkX1/Kz1ChVTs6G5MV4tXEiAXXQe08GktM1Xc=",
      mail: "U2FsdGVkX19FiSdlK/ZtCVzclFt4x3Jd45mBRjrL7PjSp/fcekw84ra+OjJoSePL",
      birth: "U2FsdGVkX1/B9mY5qu0+b0GulKCJRjRMhle5/BrVY4c=",
      occupy: "U2FsdGVkX1+QCn6286Jnh4ft9eLO+/ZC00C/hAQ0/micyJnUWLZ/U1L8iwhTEE0M"
    }
  },
  mounted () {
    var _this = this;
    ["avatar","name","phone","mail","birth","occupy"].forEach(n=>{
      _this[n] = _this.mStore.decode(_this[n]);
    });
  }
}
</script>
<style>
.content {
  width: 400px;
  /* min-height: 300px; */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.user-content {
  min-width: 250px;
  height: 200px;
  display: flex;
  padding-bottom: 25px;
}
.user-content .avatar {
    min-height: 125px;
    min-width: 125px;
}
.ivu-avatar>img {
    border-radius: 50%;
}
.left {
    min-width: 50%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.left .title {
    font-size: 20px;
}
.left .sub-title {
    font-size: 12px;
    color: #2b7cba;
}
.right-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.form-item {
    text-align: left;
    margin-bottom: 10px;
}
.form-item label {
    font-size: 14px;
    color: #CCC;
    display: block;
}
.form-input {
    width: auto;
    margin-right: 5px;
}
.form-input .ivu-input-suffix {
    display: none;
}
.form-item .ivu-input-with-suffix {
    padding-right: 7px;
}
.form-input input.main{
    font-weight: bold;
    font-size: 16px;
}
.form-input input::placeholder,input::-moz-placeholder,input::-webkit-input-placeholder {
    font-size: 14px;
    font-weight: none;
}
.form-input .ivu-input {
    border: none;
    border-bottom: 1px solid #dcdee2;
    border-radius: 0px;
    padding-left: 0;
    height: 28px;
}
.form-input .ivu-input:focus {
    /* box-shadow: 0 0 0 2px rgba(45,140,240,.2); */
    box-shadow: none;
    border-bottom: 1px solid rgba(45,140,240,.2);
    border-radius: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/level-card.vue